angular.module( 'acme.view.application.passes.detail.settings', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.detail.settings.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesDetailSettings = {
        name: 'application.passes.detail.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'PassesDetailSettingsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/detail/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'View Pass Program Settings'
        }
      };

    $stateProvider
      .state(passesDetailSettings);
});
